<div class="l-top-guidance l-top-guidance--error" *ngIf="errorInfo">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-guidance__inner">
        <p class="l-top-guidance__message">
          <em
            class="l-top-guidance__text"
            [innerHTML]="
              errorInfo.errorMsgId
                ? (msgKeyPrefix + errorInfo.errorMsgId
                    | paramsTranslate : errorInfo.params || []
                    | popupIndicator
                    | metaUrl
                    | linkStyle) + (displayErrorKey || '')
                : ('message.errorIndicator' | staticMsg)
            "
          ></em>
        </p>
      </div>
    </div>
  </div>
</div>
